import { loadConfig } from './config';

export async function api(path: string, opts: RequestInit & { token?: string } = {}) {
  const { token, headers, ...rest } = opts;
  const cfg = await loadConfig();
  const base = cfg.apiBase || '';
  const r = await fetch(`${base}${path}`, {
    ...rest,
    headers: {
      'content-type': 'application/json',
      ...(token ? { authorization: `Bearer ${token}` } : {}),
      ...headers,
    },
  });
  if (!r.ok) {
    const text = await r.text();
    throw new Error(`${r.status}: ${text}`);
  }
  return r.json();
}
